<template>
  <div></div>
</template>
<script>
export default {
  name: 'LoadSimulationInfoReport',
}; // TODO: 35519
</script>
<style scoped>
</style>
